(() => {
  if (!/\/products\//.test(location.pathname)) return;
  const controlSelector = '.swym-add-to-wishlist,.swym-add-to-wishlist-view-product';
  const excluded = '#swym-plugin,.swym-ui-component,dialog,.quickview,.product-recommendations,.rc-card,.rh-product,.product-grid,.rbe-sticky,[data-wombat-sticky],.wombat-sticky';
  const trustSelector = '.rb-pdp-purchase-trust,.rbp-trust,.rbe-trust,.wombat-trust-strip,[data-rb-block="hero"] .purchase > .trust';
  let queued = false;
  function place() {
    queued = false;
    const trust = [...document.querySelectorAll(trustSelector)].find(el => !el.closest(excluded));
    if (!trust) return;
    const parent = trust.parentElement;
    const shippingSelector = '.shipping,.rbp-shipping,.rbe-shipping,.wombat-v10-shipping';
    const deliveryParent = [parent, parent.parentElement].find(el => el && [...el.children].some(child => child.matches(shippingSelector))) || parent;
    const shipping = [...deliveryParent.children].find(el => el.matches(shippingSelector));
    const pickup = [...deliveryParent.children].find(el => el.matches('.rb-warehouse-card'));
    const estimate = [...deliveryParent.children].find(el => el.matches('rb-shipping-estimate'));
    if (shipping) {
      let anchor = shipping;
      if (estimate) {
        if (anchor.nextElementSibling !== estimate) anchor.after(estimate);
        anchor = estimate;
      }
      if (pickup && anchor.nextElementSibling !== pickup) anchor.after(pickup);
    }
    const controls = [...document.querySelectorAll(controlSelector)].filter(el => !el.closest(excluded));
    const control = controls.find(el => deliveryParent.contains(el)) || controls.find(el => el.getClientRects().length);
    if (!control) return;
    let slot = parent.querySelector('[data-p2-wishlist],[data-rb-wishlist-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'rb-pdp-wishlist swym-button-bar';
    }
    if (!slot.hasAttribute('data-rb-wishlist-slot')) slot.setAttribute('data-rb-wishlist-slot', '');
    if (trust.previousElementSibling !== slot) trust.before(slot);
    if (!slot.contains(control)) {
      const oldBar = control.closest('.swym-button-bar');
      slot.append(control.closest('.swym-btn-container') || control);
      if (oldBar && oldBar !== slot && !oldBar.querySelector(controlSelector) && !oldBar.hasAttribute('data-p2-wishlist')) oldBar.remove();
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(place);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('change', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
  schedule();
})();
